<p-toast></p-toast>
<p-toolbar styleClass="">
  <ng-template pTemplate="left">
  </ng-template>

  <ng-template pTemplate="right">
    <p-button icon="pi pi-sitemap" (onClick)="showDoctreeButtonClick($event)" [disabled]="ifThereNotSelection" class="mr-2" pTooltip="Дерево документов" tooltipPosition="top"></p-button>
    <p-button icon="pi pi-arrow-up" (onClick)="moveToParentDocumentBtn($event)" [disabled]="ifSelectedHasNotParent" class="mr-6" pTooltip="Перейти к первичному" tooltipPosition="top"></p-button>

    <p-button label="Обновить" icon="pi pi-refresh" class="mr-2" (onClick)="onReloadAllData($event)" pTooltip="Обновить список документов" tooltipPosition="top"></p-button>

    <button pButton pRipple label="Export" icon="pi pi-upload" (click)="onExportData()" [disabled]="!tableIsReady" class="p-button-help mr-2" pTooltip="Экспортировать список документов" tooltipPosition="top"></button>

  </ng-template>
</p-toolbar>
<div class="grid">
  <div class="col-12">
    <app-productselector [showLabel]="false" [allowComplex]="allowComplex" [allowOld]="allowOld" [searchText]="" (selectedProduct)="onProductSelection($event)"></app-productselector>
  </div>
</div>

<app-turnover-sheet-table [prodId]="_prodId" [product]="product" [depth]="depth"
                          state="reportTurnOverSheet-state"
                          showCaption="true"
                          showDepthSelector="true"
                          showColumnSelector="true"
                          (selectedDocumentID)="onTurnoverDocument($event)"
                          (turnoverTable)="onTurnoverTableReady($event)"
                          ></app-turnover-sheet-table>
